import { get, post } from "../common/query";
export const GET_MYINFO = data => get("/user/getMyInfo", data);
export const SET_MYINFO = data => post("/user/edit", data);
